import { useEffect, useState } from 'react';
import { fetchMadeiras } from '../../services/madeiraService';
import { Madeira } from '../../interfaces/madeira.interface';

const useFetchMadeiras = () => {
  const [madeiras, setMadeiras] = useState<Madeira[]>([]);
  const [madeiraLoading, setMadeiraLoading] = useState(true);
  const [madeiraError, setMadeiraError] = useState<string | null>(null);

  useEffect(() => {
    const getMadeiras = async () => {
      try {
        const data = await fetchMadeiras();
        setMadeiras(data);
      } catch (err) {
        setMadeiraError('Falha ao buscar madeiras');
      } finally {
        setMadeiraLoading(false);
      }
    };

    getMadeiras();
  }, []);

  return { madeiras, madeiraLoading, madeiraError };
};

export default useFetchMadeiras;
